import React, {useEffect, useState, useRef} from 'react'
import { Link } from 'react-router-dom'
// import {options} from './Options'
import Multiselect from 'multiselect-react-dropdown'
import Select from 'react-select'
import { setYear } from 'date-fns'
import Sidebar from '../Sidebar'
// import env from 'react-dotenv'
export default function CropConditionForm() {
  //states
  const [form, setForm] = useState({
    year:'',
    district:'',
    district_id:'',
    avg_ball_no:'',
    crop_condition:''
  })
  //for getting to the item quicker
  const [options2, setOptions2] = useState([])
  const [selectedOptions, setSelectedOptions] = useState('')
  const [selectedOptions2, setSelectedOptions2] = useState('')
  //Districts
  const [options, setOptions] =useState([])

  const [cotton_picking, setCP] =useState({
    curr_year:"",
    prev_year:""
  })

  const [avg_yield_per_acre, setTYPA] = useState({
    curr_year:"",
    prev_year:""
  })

  const [pest_attacked,setPA] = useState([{
    pest_name:"",
    number_attacked:""
  }])

  
  useEffect(()=>{
    const crickets = options
    const searchTerm = crickets.map((cricket) => ({
      value: cricket.name,
      label: cricket.name
    }));
    setOptions2(searchTerm)
  }, [options])
  const ferrit = async() =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/getDistrictsForCropCondition`,{
      headers: {
        'x-access-token': token
      }
    })
    const data = await response.json()
    setOptions(data)
   // console.log(data)
  }
  useEffect(()=>{
    ferrit()
  },[])

  
  

  //handle click
  const handleClick = () =>{
    setPA([...pest_attacked, {pest_name:"", number_attacked:""}])
  }

   //handle change
   const handleChange = (e, i) => {
    const { name, value } = e.target;
    const onChangeVal = [...pest_attacked];
    onChangeVal[i][name] = value;
    setPA(onChangeVal);
  };

  //handle delete
  const handleDelete = (i) =>{
    const deleteVal = [...pest_attacked]
    deleteVal.splice(i,1)
    setPA(deleteVal)
}
  //references
  const ref1 = useRef()
  const refa = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const ref4 = useRef()
  const ref5 = useRef()
  const ref6 = useRef()
  const ref7 = useRef()
  const ref8 = useRef()
  const ref9 = useRef()


  const districtHandler = (item) => {
    const selectedName = item;
    const selected = options.find(option => option.name === selectedName);
   // console.log(selected)
    setForm({...form, district:selectedName, district_id: String(selected.value)})
  };


  //ball no. handler
  const avgBallNoHandler = (e)=>{
    setForm({...form, avg_ball_no:e.target.value})
  }

  //crop condition handler
  const cropConditionHandler =(e) =>{
    setForm({...form, crop_condition:e.target.value})
  }

  //yearHandler
  const yearHandler = (e) =>{
    const x = e.target.value
    setForm({...form, year:x})
  }

   //previous year for AYPA handler
  const pYearHandler = (e) =>{
    setTYPA({...avg_yield_per_acre, prev_year:e.target.value})
  }

   //current Year for AYPA handler
   const cYearHandler = (e) =>{
    setTYPA({...avg_yield_per_acre, curr_year:e.target.value})
  }

  //previous year for CP handler
  const prYearHandler = (e) =>{
    setCP({...cotton_picking, prev_year:e.target.value})
  }

   //current Year for CP handler
   const crYearHandler = (e) =>{
    setCP({...cotton_picking, curr_year:e.target.value})
  }

  //useEffect for year
  useEffect(()=>{
   // console.log(form)
  },[form.year])
  //reset
  const reset = () =>{
    refa.current.value=''
    ref1.current.value=''
    ref2.current.value=''
    ref3.current.value=''
    ref4.current.value=''
    ref5.current.value=''
    ref6.current.value=''
    ref7.current.value=''
    ref8.current.value=''
    ref9.current.value=''
    setForm({
      district:'',
      year:'',
      district_id:'',
      avg_ball_no:'',
      crop_condition:''
    })
    setCP({
      curr_year:'',
      prev_year:''
    })
    setTYPA({
      curr_year:'',
      prev_year:''
    })
    setPA([{
      pest_name:'',
      number_attacked:''
    }])
    
    setSelectedOptions(null)
    setSelectedOptions2(null)
  }

  useEffect(()=>{
   // console.log("This is the form district",form.district_id)
  },[form])

  const handleSubmit = async (e)=>{
    e.preventDefault()
    const token = sessionStorage.getItem('token')
      const sub = {...form, pest_attacked:pest_attacked, avg_yield_per_acre:avg_yield_per_acre, cotton_picking:cotton_picking}
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin_crop_condition/crop_condition/create_single`,{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'x-access-token':token
      },
      body:JSON.stringify(sub)
    })
        // .then(console.log('Submitted successfully')).then(reset())
    
  }
  return (
    
<>
<div className="sidebar">
    <Sidebar/>
  </div>
<div id='tabler'> 

    <h1>Crop Condition Form</h1>

    

      <form onSubmit={handleSubmit} className='needs-validation'>

        <div className='row'>
          <div className='col-md-6'>
          <label htmlFor="num-value" className="form-label">Year</label>
            <div class="input-group mb-3">
            <select className="form-select" ref={refa}  id="num-value" onChange={yearHandler} required aria-label="Select example">
                          <option value="">Select year</option>
                          <option value="2025-26">2025-26</option>
                          <option value="2024-25">2024-25</option>
                          <option value="2023-24">2023-24</option>
                          <option value="2022-23">2022-23</option>
                          <option value="2021-22">2021-22</option>
                          <option value="2020-21">2020-21</option>
                          <option value="2019-20">2019-20</option>
                          <option value="2018-19">2018-19</option>
                          <option value="2017-18">2017-18</option>
                          <option value="2016-17">2016-17</option>
                          <option value="2015-16">2015-16</option>
                          <option value="2014-15">2014-15</option>
                          <option value="2013-14">2013-14</option>
                          <option value="2012-13">2012-13</option>
                          <option value="2011-12">2011-12</option>
                          <option value="2010-11">2010-11</option>
                          </select>       
                          </div>
          </div>  

          <div className="col-md-6">
          <label htmlFor="inputGroupSelect07" className="form-label">District</label>
                  <Select options={options2} ref={ref1} value={selectedOptions}  placeholder="district"  onChange={(stat)=>{
                   // console.log("This is the value", stat)
                    const {value, label} = {...stat}
                   // console.log(value, label)
                    setSelectedOptions(stat)
                    districtHandler(value)
                  }} isSearchable noOptionsMessage={()=> "Not found"} required/>
          </div>
          
        </div>
  
                  
        
            <div>
                <label htmlFor="num-value" className="form-label">
                    Cotton Picking
                </label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom:"20px" }}>
                <div style={{width:"50%"}}>
                    <label htmlFor="num-value" className="form-label" style={{color:"grey"}}>
                        Current Year
                    </label>
                    <input
                        type="number"
                        ref={ref2}
                        min="0"
                        className="form-control"
                        onChange={crYearHandler}
                        id="num-value"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-default"
                        required
                    />
                </div>
                <div style={{ marginLeft: '20px', width:"50%" }}>
                    <label htmlFor="num-value" className="form-label" style={{color:"grey"}}>
                        Previous Year
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        min="0"
                        ref={ref3}
                        onChange={prYearHandler}
                        id="num-value"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-default"
                        required
                    />
                </div>
            </div>




            <div>
                <label htmlFor="num-value" className="form-label">
                    Average Yield Per Acre
                </label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom:"20px"  }}>
                <div style={{width:"50%"}}>
                    <label htmlFor="num-value" className="form-label" style={{color:"grey"}}>
                        Current Year
                    </label>
                    <input
                        type="number"
                        ref={ref4}
                        className="form-control"
                        min="0"
                        onChange={cYearHandler}
                        id="num-value"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-default"
                        required
                    />
                </div>
                <div style={{ marginLeft: '20px' , width:"50%"}}>
                    <label htmlFor="num-value" className="form-label" style={{color:"grey"}}>
                        Previous Year
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        min="0"
                        ref={ref5}
                        onChange={pYearHandler}
                        id="num-value"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-default"
                        required
                    />
                </div>
            </div>


            <div className="row" >
        <div className="col-md-6">
        <label htmlFor="num-value" className="form-label">Average Number of Balls</label>
      <div class="input-group mb-3">
        <input ref={ref8} type="number" min={0} class="form-control"  onChange={avgBallNoHandler}  id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/>
       </div>
        </div>

        <div className="col-md-6">
        <label htmlFor="num-value" className="form-label">Crop Condition</label>
      <div class="input-group mb-3">
        {/* <input type="text" class="form-control" value={form.crop_condition} ref={cRef} onChange={cropConditionHandler} id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/> */}
       <select ref={ref9} className="form-select" value={form.crop_condition}   onChange={cropConditionHandler} id='num-value' required>
       <option>Select...</option>
    <option>Good</option>
    <option>Average</option>
    <option>Excellent</option>
  </select>
       </div>
        </div>

</div>

<div style={{ display: 'flex', alignItems: 'center', justifyContent:"space-between", gap: '20px' }}>
  <label htmlFor="num-value" className="form-label" style={{ display: 'flex', alignItems: 'center', marginRight: '650px' }}>
       Pest Attacked
    </label>
    <button type="button" className="btn btn-dark" onClick={handleClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
      </svg>
    </button>
</div>
       {pest_attacked.map((val, i) => (
  <div key={i} id={`num-value-lo-${i}`} style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom:"20px"  }}>
    <div style={{ width: "50%" }}>
      <label htmlFor={`num-value-cro-lo-${i}`} style={{color:"grey"}} className="form-label">Pest Name</label>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          name="pest_name"
          ref={ref6}
          value={val.pest_name}
          onChange={(e) => { handleChange(e, i) }}
          id={`num-value-cro-lo-${i}`}
          aria-label="Sizing example input"
          aria-describedby="inputGroup-sizing-default"
          required
          style={{ width: '100%' }} // Adjust width as needed
        />
      </div>
    </div>

    <div style={{ width: "50%" }}>
      <label htmlFor={`num-value-am-lo-${i}`} style={{color:"grey"}}  className="form-label">Percentage</label>
      <div className="input-group">
        <input
        min={0}
          type="number"
          ref={ref7}
          className="form-control"
          name='number_attacked'
          value={val.number_attacked}
          onChange={(e) => { handleChange(e, i) }}
          id={`num-value-am-lo-${i}`}
          aria-label="Sizing example input"
          aria-describedby="inputGroup-sizing-default"
          required
          style={{ width: '100%' }} // Adjust width as needed
        />
      </div>
      
    </div>
    <br />
    <div style={{ alignSelf:"flex-end"}}>
      <button style={{borderRadius:"15%", color:"red", border:"1px solid red", backgroundColor:"#FFC0CB"}} type="button" className="btn btn-red" onClick={() => handleDelete(i)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
        </svg>
      </button>
    </div>
  </div>
))}       

       <button type="submit"  className="btn submit-btn">Submit</button>
      </form>
    </div>

</>
  )
}
